import PATH from '../paths';

const name = 'XUSA and Taylor Capital';
const key = 'xusa';
const imgUrl = `${ PATH.CDN }/whitelabels/${ key }`;
const images = {
  favicon: `${ imgUrl }/favicon.png`,
  logo: `${ imgUrl }/xusa-taylor-capital-logo.png`,
  logoSidebar: `${ imgUrl }/xusa-taylor-capital-sidebar-logo.png`,
  logoPDF: `${ imgUrl }/logo-pdf.png`,
  opengraph: false,
  backgrounds: [
    `${ imgUrl }/bg-compressor.jpg`
  ],
};

export default {
  name,
  key,
  images,
  stylesheet: `
    /* COLOR VARIABLES +++++++++++++++++++++++++++++++++++++++++++++++++++++  */


    --color-xusa-red:                 #D25E39;
    --color-xusa-blue:                #304357;
    --color-xusa-blueLight:           #818a91;

    --color-primary:                  var(--color-xusa-blueLight);
    --color-secondary:                var(--color-xusa-blue);
    --color-accent:                   var(--color-xusa-red);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* TYPOGRAPHY ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    --color-link:                     var(--color-xusa-red);
    --color-link-hover:               var(--color-darker);

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
   
    /* LAYOUTS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* ANONYMOUS LAYOUT */

    --anonymous-logo-bg:              var(--color-white);
    --anonymous-copy-bg:              var(--color-xusa-blue);
    --anonymous-heading-color:        var(--color-xusa-red);
    --anonymous-subheading-color:     var(--color-white);
    --anonymous-text-color            var(--color-white);
    --anonymous-logo-height:          50px;
    --anonymous-bg:                   url(${ images.backgrounds[0] });
    --anonymous-bg-size:              cover;

    /* END */

    /* SIDEBAR */

    --sidebar-bg-color: var(--color-xusa-blue);
    --sidebar-logo-bg-color: var(--color-white);
    --sidebar-logo-height: 45px;
    --sidebar-label-color: rgba(var(--color-white-rgb), 0.7);
    --sidebar-border-color: var(--color-xusa-blueLight);

    --sidebar-button-color: var(--color-accent);
    --sidebar-button-color-active: var(--color-xusa-blue);
    --sidebar-button-color-hover: var(--color-xusa-blue);
    --sidebar-button-bg-color: transparent;
    --sidebar-button-bg-color-active: var(--color-accent);
    --sidebar-button-bg-color-hover: var(--color-accent);
    --sidebar-button-border-color: var(--color-accent);
    --sidebar-button-border-color-active: var(--color-accent);
    --sidebar-button-border-color-hover: var(--color-accent);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* BUTTONS +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */

    /* PRIMARY BUTTON */

    --btn-primary--bg:                var(--color-xusa-blue);
    --btn-primary--border:            var(--color-xusa-blue);
    --btn-primary--color:             var(--color-white);
    --btn-primary--colorH:            var(--color-white);
    --btn-primary--bgH:               var(--color-xusa-red);
    --btn-primary--borderH:           var(--color-xusa-red);

    /* END */

    /* SECONDARY BUTTON */

    --btn-secondary--bg:              transparent;
    --btn-secondary--border:          var(--color-xusa-red);
    --btn-secondary--color:           var(--color-xusa-blue);
    --btn-secondary--bgH:             transparent;
    --btn-secondary--borderH:         var(--color-xusa-red);
    --btn-secondary--colorH:          var(--color-xusa-red);

    /* END */

    /* END +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++  */
  `,
};
